import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAccessToken } from '../auth/use-access-token.js';
import { readOwnSignature, type SignatureView } from '../api/signature-view.js';
import { SignatureCodeLine } from './signature-codes.js';

/**
 * Your own Performance Signature on Account, under your card (parents and the
 * coach, approved 25 October). A parent: a row once the coach has entered
 * theirs, opening their pages - only they see it. The coach: always a row,
 * opening the editor for their own.
 */
export function OwnSignatureRow({ coach }: { coach: boolean }) {
  const getToken = useAccessToken();
  const [view, setView] = useState<SignatureView | null | undefined>(undefined);

  useEffect(() => {
    let live = true;
    readOwnSignature(getToken)
      .then((own) => {
        if (live) setView(own.signature);
      })
      .catch(() => {
        if (live) setView(null);
      });
    return () => {
      live = false;
    };
  }, [getToken]);

  if (view === undefined || (!coach && view === null)) return null;

  return (
    <Link className="hour-row" to={coach ? '/coach/signature' : '/account/signature'}>
      <span className="hour-row-text">
        <span className="name">{coach ? 'My Performance Signature' : 'Performance Signature'}</span>
        {view ? <SignatureCodeLine codes={view.codes} /> : <span className="detail">No profile yet</span>}
      </span>
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
